import { IconProps } from './icon';
import React from 'preact/compat';

export const CrossIcon: React.FC<IconProps> = ({ title, role, ariaHidden }) => {
  return (
    <svg width="10" viewBox="0 0 10 10" role={role} aria-hidden={ariaHidden}>
      {title && <title>{title}</title>}
      <path
        d="M9.677 8.118a1.102 1.102 0 11-1.559 1.56L5 6.558 1.882 9.677a1.102 1.102 0 11-1.56-1.559L3.442 5 .323 1.882A1.102 1.102 0 111.882.322L5 3.442 8.118.323a1.102 1.102 0 111.56 1.559L6.558 5l3.118 3.118z"
        fill="currentColor"
        fill-rule="nonzero"
      ></path>
    </svg>
  );
};
